<template>

	<v-tooltip right>
		<template v-slot:activator="{ on }">
			<div class="token-info-wrapper" v-on="on">
				<span :id="'eth-token-' + randomId" class="eth-token-info">ETH</span>
			</div>
		</template>
		<div>
			<strong>{{ $t('common.token.name') }}</strong>: Ether <br />
			<strong>{{ $t('common.token.symbol') }}</strong>: ETH <br />
		</div>
	</v-tooltip>

</template>

<script>

export default {
	name: 'ETHToken',
	data () {
		return {}
	},
	computed: {
		randomId: function () {
			return Math.ceil(Math.random()*10000000000000)
		}
	},
	methods: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eth-token-info {
	background-color: #353535;
	padding: 6px;
	font-weight: 700;
	border-radius: 2px;
	color: #fff !important;
	margin: 2px;
}
.eth-token-info:hover {
	cursor: pointer;
}
</style>
